// @ts-check
import React, { Component } from 'react'
import {
    Grid,
    Card,
    Table,
    Page,
    StatsCard,
    Form, Button
} from "tabler-react";
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
// import SiteWrapper from "../SiteWrapper.client.react";
import SiteWrapperSuperAdmin from "../SiteWrapper.superadmin.react";
import authActions from "../../redux/auth/action";
import clientService from "../../services/client";
import DownloadPopup from './downloadPopup';
import C3Chart from "react-c3js";
import * as d3 from 'd3'
import DatePicker from "react-datepicker";

import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import "tabler-react/dist/Tabler.css";
import '../../c3jscustom.css';
import 'c3/c3.css';

const _ = require('lodash');
const moment = require('moment');

export default class TimeToAnswer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            answerChatGraph: {
                x: "x",
                columns: [["x"], ["Average (in min)"]],
            },
            startDateForAnswerChatGraph: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
            endDateForAnswerChatGraph: new Date(),
        }

    }

    componentDidMount() {
        this.getAnalyticsChatGraph(this.state.startDateForAnswerChatGraph, this.state.endDateForAnswerChatGraph);
    }
    handlerAllChatDateChanger(type, event) {
        if (type === "startDateAnswerChatGraph") {
            this.setState({ startDateForAnswerChatGraph: event })
        }
        if (type === "endDateAnswerChatGraph") {
            this.setState({ endDateForAnswerChatGraph: event })
        }
    }


    DataChangeForAnswerChatGraph = async (e) => {
        e.preventDefault();
        this.getAnalyticsChatGraph(this.state.startDateForAnswerChatGraph, this.state.endDateForAnswerChatGraph);
    };

    async getAnalyticsChatGraph(startDate, endDate) {
        await clientService.getAnalyticsChatGraph(startDate, endDate).then((res) => {
            let data = {
                x: "x",
                columns: [["x"], ["Average (in min)"]],
            };
            if (res.statusCode === 200 && res && res.data.length) {
                console.log("ANALYTICS BACKEND DATA TIME TO ANSWER", res.data);
                console.log("<> mydata123", res.data.map((m) => `${((m.hour + 11) % 12) + 1} ${m.hour >= 12 ? "pm" : "am"}`));
                // console.log("<> mydata2", res.data.map((m) => m.avg));
                let myData = res.data.filter((el) => el._id.hour + 5 > 7 && 22 > el._id.hour + 5).map((el) => ({
                    ...el,  // why is it _id
                    hour: el._id.hour + 5, // +5 is  to convert from UTC to IST
                    avg: el.avg ? el.avg : 0  // null check
                }));
                data = {
                    x: "x",
                    columns: [["x", ...myData.map((m, i) => `${((m.hour + 11) % 12) + 1} ${m.hour >= 12 ? "pm" : "am"}`)], ["Average (in min)", ...myData.map((m) => parseFloat((m.avg / (1000 * 60)).toFixed(2)))]],
                };

                this.setState(prevstate => ({
                    answerChatGraph: data
                }));
            }
            else {
                //  set values to zero
                this.setState(prevstate => ({
                    answerChatGraph: {
                        ...prevstate.answerChatGraph,
                        columns: [
                            prevstate.answerChatGraph.columns[0],
                            prevstate.answerChatGraph.columns[1].map((el, i) => (i != 0 ? 0 : el))
                        ]
                    }
                }))
            }
        }).catch(error => console.error(error));
    }

    getTimeToAnswerAxis() {
        let axis = {
            x: {
                type: "category",
                tick: {
                    // precision: 0,
                    beginAtZero: true,
                    // rotate: 75,
                    // rotate: 75,
                    multiline: false,
                },
                height: 130,
                unload: true,
            },
            y: {
                tick: {
                    beginAtZero: true,
                    // precision: 0,
                    // beginAtZero: true,
                },
                // show: true,
                unload: true,
            },
        };
        return axis;
    }


    render() {
        return (
            <>
                <div className="box-al mar-40">
                    <form onSubmit={this.DataChangeForAnswerChatGraph}>
                        <div className="row">
                            <div className="col col-6 col-sm-4 col-lg-3">
                                <label className="form-label">From Date</label>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.startDateForAnswerChatGraph}
                                    onChange={(e) => this.handlerAllChatDateChanger("startDateAnswerChatGraph", e)}
                                    maxDate={this.state.endDateForAnswerChatGraph}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                />
                            </div>

                            <div className="col col-6 col-sm-4 col-lg-3">
                                <label className="form-label">To Date</label>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.endDateForAnswerChatGraph}
                                    onChange={(e) => this.handlerAllChatDateChanger("endDateAnswerChatGraph", e)}
                                    maxDate={new Date()}
                                    minDate={this.state.startDateForAnswerChatGraph}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="DD/MM/YYYY"
                                />
                            </div>

                            <div className="col col-6 col-sm-4 col-lg-3">
                                <br />
                                <Button color="primary sub1">Submit</Button>
                            </div>


                        </div>
                    </form>
                </div>
                <div className="col col-12 col-sm-12 col-lg-12">
                    <div className="box-3rd card card101">
                        <div className="bar-context row">
                            <div className=" pull-left col col-12 col-sm-12 col-lg-7">
                                <h3 className="card-title"> Time to answer </h3>
                            </div>
                        </div>
                        <div className="card-body p-3 text-center">
                            <C3Chart
                                size={{
                                    height: 500,
                                }}

                                padding={{
                                    left: 100,
                                    right: 50,
                                }}

                                data={this.state.answerChatGraph}

                                legend={{
                                    show: true,
                                }}
                                axis={this.getTimeToAnswerAxis()}
                            />
                        </div>
                        <div />
                    </div>
                </div>
            </>
        )
    }
}
